/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductActiveAdGetRequest } from '../models/product-active-ad-get-request';
import { ProductActiveAdGetResponse } from '../models/product-active-ad-get-response';
import { ProductAdClassificationGetRequest } from '../models/product-ad-classification-get-request';
import { ProductAdClassificationGetResponse } from '../models/product-ad-classification-get-response';
import { ProductAdClassificationListGetResponse } from '../models/product-ad-classification-list-get-response';
import { ProductAdCreateRequest } from '../models/product-ad-create-request';
import { ProductAdCreateResponse } from '../models/product-ad-create-response';
import { ProductAdGetRequest } from '../models/product-ad-get-request';
import { ProductAdGetResponse } from '../models/product-ad-get-response';
import { ProductAdListGetRequest } from '../models/product-ad-list-get-request';
import { ProductAdListGetResponse } from '../models/product-ad-list-get-response';
import { ProductAdTypeGetRequest } from '../models/product-ad-type-get-request';
import { ProductAdTypeGetResponse } from '../models/product-ad-type-get-response';
import { ProductAdTypeListGetResponse } from '../models/product-ad-type-list-get-response';
import { ProductAdUpdateRequest } from '../models/product-ad-update-request';
import { ProductAdUpdateResponse } from '../models/product-ad-update-response';

@Injectable({
  providedIn: 'root',
})
export class AdsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1AdsGetPost
   */
  static readonly V1AdsGetPostPath = '/v1/ads/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetPost$Plain$Response(params?: {
    body?: ProductAdGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetPost$Plain(params?: {
    body?: ProductAdGetRequest
  },
  context?: HttpContext

): Observable<ProductAdGetResponse> {

    return this.v1AdsGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdGetResponse>) => r.body as ProductAdGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetPost$Json$Response(params?: {
    body?: ProductAdGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetPost$Json(params?: {
    body?: ProductAdGetRequest
  },
  context?: HttpContext

): Observable<ProductAdGetResponse> {

    return this.v1AdsGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdGetResponse>) => r.body as ProductAdGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsGetActivePost
   */
  static readonly V1AdsGetActivePostPath = '/v1/ads/get-active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsGetActivePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetActivePost$Plain$Response(params?: {
    body?: ProductActiveAdGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductActiveAdGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsGetActivePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductActiveAdGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsGetActivePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetActivePost$Plain(params?: {
    body?: ProductActiveAdGetRequest
  },
  context?: HttpContext

): Observable<ProductActiveAdGetResponse> {

    return this.v1AdsGetActivePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductActiveAdGetResponse>) => r.body as ProductActiveAdGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsGetActivePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetActivePost$Json$Response(params?: {
    body?: ProductActiveAdGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductActiveAdGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsGetActivePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductActiveAdGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsGetActivePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsGetActivePost$Json(params?: {
    body?: ProductActiveAdGetRequest
  },
  context?: HttpContext

): Observable<ProductActiveAdGetResponse> {

    return this.v1AdsGetActivePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductActiveAdGetResponse>) => r.body as ProductActiveAdGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsListPost
   */
  static readonly V1AdsListPostPath = '/v1/ads/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsListPost$Plain$Response(params?: {
    body?: ProductAdListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsListPost$Plain(params?: {
    body?: ProductAdListGetRequest
  },
  context?: HttpContext

): Observable<ProductAdListGetResponse> {

    return this.v1AdsListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdListGetResponse>) => r.body as ProductAdListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsListPost$Json$Response(params?: {
    body?: ProductAdListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsListPost$Json(params?: {
    body?: ProductAdListGetRequest
  },
  context?: HttpContext

): Observable<ProductAdListGetResponse> {

    return this.v1AdsListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdListGetResponse>) => r.body as ProductAdListGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsCreatePost
   */
  static readonly V1AdsCreatePostPath = '/v1/ads/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsCreatePost$Plain$Response(params?: {
    body?: ProductAdCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsCreatePost$Plain(params?: {
    body?: ProductAdCreateRequest
  },
  context?: HttpContext

): Observable<ProductAdCreateResponse> {

    return this.v1AdsCreatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdCreateResponse>) => r.body as ProductAdCreateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsCreatePost$Json$Response(params?: {
    body?: ProductAdCreateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdCreateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdCreateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsCreatePost$Json(params?: {
    body?: ProductAdCreateRequest
  },
  context?: HttpContext

): Observable<ProductAdCreateResponse> {

    return this.v1AdsCreatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdCreateResponse>) => r.body as ProductAdCreateResponse)
    );
  }

  /**
   * Path part for operation v1AdsUpdatePost
   */
  static readonly V1AdsUpdatePostPath = '/v1/ads/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsUpdatePost$Plain$Response(params?: {
    body?: ProductAdUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsUpdatePost$Plain(params?: {
    body?: ProductAdUpdateRequest
  },
  context?: HttpContext

): Observable<ProductAdUpdateResponse> {

    return this.v1AdsUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdUpdateResponse>) => r.body as ProductAdUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsUpdatePost$Json$Response(params?: {
    body?: ProductAdUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsUpdatePost$Json(params?: {
    body?: ProductAdUpdateRequest
  },
  context?: HttpContext

): Observable<ProductAdUpdateResponse> {

    return this.v1AdsUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdUpdateResponse>) => r.body as ProductAdUpdateResponse)
    );
  }

  /**
   * Path part for operation v1AdsTypeGetPost
   */
  static readonly V1AdsTypeGetPostPath = '/v1/ads/type/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsTypeGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsTypeGetPost$Plain$Response(params?: {
    body?: ProductAdTypeGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdTypeGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsTypeGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdTypeGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsTypeGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsTypeGetPost$Plain(params?: {
    body?: ProductAdTypeGetRequest
  },
  context?: HttpContext

): Observable<ProductAdTypeGetResponse> {

    return this.v1AdsTypeGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdTypeGetResponse>) => r.body as ProductAdTypeGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsTypeGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsTypeGetPost$Json$Response(params?: {
    body?: ProductAdTypeGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdTypeGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsTypeGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdTypeGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsTypeGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsTypeGetPost$Json(params?: {
    body?: ProductAdTypeGetRequest
  },
  context?: HttpContext

): Observable<ProductAdTypeGetResponse> {

    return this.v1AdsTypeGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdTypeGetResponse>) => r.body as ProductAdTypeGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsTypeListPost
   */
  static readonly V1AdsTypeListPostPath = '/v1/ads/type/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsTypeListPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsTypeListPost$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdTypeListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsTypeListPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdTypeListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsTypeListPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsTypeListPost$Plain(params?: {
  },
  context?: HttpContext

): Observable<ProductAdTypeListGetResponse> {

    return this.v1AdsTypeListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdTypeListGetResponse>) => r.body as ProductAdTypeListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsTypeListPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsTypeListPost$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdTypeListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsTypeListPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdTypeListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsTypeListPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsTypeListPost$Json(params?: {
  },
  context?: HttpContext

): Observable<ProductAdTypeListGetResponse> {

    return this.v1AdsTypeListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdTypeListGetResponse>) => r.body as ProductAdTypeListGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsClassificationGetPost
   */
  static readonly V1AdsClassificationGetPostPath = '/v1/ads/classification/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsClassificationGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsClassificationGetPost$Plain$Response(params?: {
    body?: ProductAdClassificationGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdClassificationGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsClassificationGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdClassificationGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsClassificationGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsClassificationGetPost$Plain(params?: {
    body?: ProductAdClassificationGetRequest
  },
  context?: HttpContext

): Observable<ProductAdClassificationGetResponse> {

    return this.v1AdsClassificationGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdClassificationGetResponse>) => r.body as ProductAdClassificationGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsClassificationGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsClassificationGetPost$Json$Response(params?: {
    body?: ProductAdClassificationGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdClassificationGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsClassificationGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdClassificationGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsClassificationGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1AdsClassificationGetPost$Json(params?: {
    body?: ProductAdClassificationGetRequest
  },
  context?: HttpContext

): Observable<ProductAdClassificationGetResponse> {

    return this.v1AdsClassificationGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdClassificationGetResponse>) => r.body as ProductAdClassificationGetResponse)
    );
  }

  /**
   * Path part for operation v1AdsClassificationListPost
   */
  static readonly V1AdsClassificationListPostPath = '/v1/ads/classification/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsClassificationListPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsClassificationListPost$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdClassificationListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsClassificationListPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdClassificationListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsClassificationListPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsClassificationListPost$Plain(params?: {
  },
  context?: HttpContext

): Observable<ProductAdClassificationListGetResponse> {

    return this.v1AdsClassificationListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdClassificationListGetResponse>) => r.body as ProductAdClassificationListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1AdsClassificationListPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsClassificationListPost$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductAdClassificationListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdsService.V1AdsClassificationListPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductAdClassificationListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1AdsClassificationListPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1AdsClassificationListPost$Json(params?: {
  },
  context?: HttpContext

): Observable<ProductAdClassificationListGetResponse> {

    return this.v1AdsClassificationListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductAdClassificationListGetResponse>) => r.body as ProductAdClassificationListGetResponse)
    );
  }

}
